// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ec05fa1","453":"47e02b2d","455":"a35cc695"}[chunkId] + ".chunk.js";
};